module.exports = __webpack_public_path__ + "components/check-list/static/cross-circle-b51a0a8c1c77dc5011a15b29000103c6.svg";